import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { mediaUrl } from '../services/api';

type HashLinkProps = {
  to: string;
  className?: string;
  children: ReactNode;
  style?: React.CSSProperties;
};

/** #anchor -> ayni sayfada kaydirma; /path -> router linki; http -> dis link */
export function HashLink({ to, className, children, style }: HashLinkProps) {
  if (to.startsWith('#')) {
    const handleClick = (e: React.MouseEvent) => {
      const el = document.getElementById(to.slice(1));
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth' });
      }
    };
    return (
      <a href={to} className={className} style={style} onClick={handleClick}>
        {children}
      </a>
    );
  }
  // Portalda yuklenen dokuman/medya linkleri (/api/dokumanlar/..., /uploads/...) Port_Api'de durur
  const fileUrl = /^\/(api|uploads)\//i.test(to) ? mediaUrl(to) : undefined;
  if (fileUrl) {
    return (
      <a href={fileUrl} className={className} style={style} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  }
  if (/^https?:\/\//.test(to)) {
    return (
      <a href={to} className={className} style={style} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  }
  return (
    <Link to={to} className={className} style={style}>
      {children}
    </Link>
  );
}
